import { Card, Form, FloatingLabel, Modal } from 'react-bootstrap';
import { FC, useState } from 'react';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetCurrentUser, useGetIsDarkMode } from 'src/custom-hooks';
import { userServices } from 'src/services';

type propsType = {
    closeModal: () => void;
    openAlertModalHandler: (title: string, message: string, animation?: number) => void;
    openConfirmModalHandler: (title: string, message: string, execution: Function) => void;
};

export const UserChangePassword: FC<propsType> = ({ closeModal, openAlertModalHandler, openConfirmModalHandler }) => {
    const [newPsw, setNewPsw] = useState('');
    const [psw, setPsw] = useState('');
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const user = useGetCurrentUser();

    const changePswHandler = () => {
        if (!psw || !newPsw || psw.length < 8) {
            openAlertModalHandler("Completar los campos primero", "", 2);
            return;
        }
        if (newPsw.length < 8) {
            openAlertModalHandler("La clave debe tener al menos 8 caracteres", "", 2);
            return;
        }
        openConfirmModalHandler(
            "Atención",
            `Se cambiará la contraseña de ${psw} a ${newPsw}`,
            async () => {
                dispatch(showLoadingModalReducer());
                const response = await userServices.ChangeMyPassword(user.congregation, psw, newPsw, null);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                openAlertModalHandler("Clave cambiada con éxito", "", 1);
                closeModal();
            }
        );
    }

    return (
        <Modal
            centered
            fullscreen={'md-down'}
            onHide={closeModal}
            show
            size={'lg'}
        >
            <style>
                {'.btn-close { background-color: white; }'}
            </style>
            <Modal.Header className={'bg-dark text-white'} closeButton>
                <Modal.Title>
                    CAMBIAR LA CONTRASEÑA
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={'bg-lightdark text-white'}>
                <Card className={isDarkMode ? 'bg-dark text-white' : ''}
                    style={{ margin: '60px auto', maxWidth: '450px', padding: '25px' }}
                >
                    <Form.Group>
                        <FloatingLabel
                            label={"Contraseña actual"}
                            className={'mb-3 text-secondary'}
                        >
                            <Form.Control type={'text'}
                                placeholder={""}
                                value={psw}
                                onChange={e => setPsw(e.target.value)}
                                autoFocus
                            />
                        </FloatingLabel>
                    </Form.Group>
                    <Form.Group>
                        <FloatingLabel
                            label={"Nueva contraseña"}
                            className={'text-secondary mb-3'}
                        >
                            <Form.Control type={'text'}
                                placeholder={""}
                                value={newPsw}
                                onChange={e => setNewPsw(e.target.value)}
                                onKeyDown={e => e.key === 'Enter' ? changePswHandler() : null }
                            />
                        </FloatingLabel>
                    </Form.Group>
                    <button className={'btn btn-general-blue my-2'}
                        onClick={changePswHandler}
                    >
                        Aceptar
                    </button>
                    <button className={'btn btn-general-red'}
                        onClick={closeModal}
                    >
                        Cancelar
                    </button>
                </Card>
            </Modal.Body>
        </Modal>
    );
}
